import { useContext } from 'react';
import ApplicationFormContext from './ApplicationFormContext';

export default function useApplicationFormContext() {
  const context = useContext(ApplicationFormContext);
  if (!context) {
    throw new Error(
      'useApplicationFormContext must be wrapped by ApplicationFormContext.Provider',
    );
  }
  return context;
}
